<template>
  <v-row>
    <v-col cols="12" lg="6">
      <naj-input
        :type-id="formFieldType.date"
        :label="startDateLabel || local.common.fromDate"
        @change="updateStartDate"
        :value.sync="start"
        :validates="validates"
      ></naj-input>
    </v-col>
    <v-col cols="12" lg="6">
      <naj-input
        :type-id="formFieldType.date"
        :label="endDateLabel || local.common.toDate"
        @change="updateEndDate"
        :min-date="minEndDate"
        :value.sync="end"
        :validates="validates"
      ></naj-input>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'naj-date-range',
  props: {
    startDate: {
      required: true,
    },
    endDate: {
      required: true,
    },
    startDateLabel: {
      type: String,
      required: false,
    },
    endDateLabel: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
    },
  },
  data () {
    return {
      start: null,
      end: null,
    };
  },
  computed: {
    minEndDate () {
      if (!this.start) return null;
      const arr = this.start.split('-');
      const lastItem = String(+arr[arr.length - 1] + 1);
      arr[arr.length - 1] = lastItem.length === 1 ? '0' + lastItem : lastItem;
      return new Date(arr.join('-'));
    },
    validates () {
      return this.required ? 'required' : '';
    },
  },
  methods: {
    updateStartDate (value) {
      this.start = value;
      this.emitChange();
      this.$emit('update:startDate', value);
      this.updateEndDate(null);
    },
    updateEndDate (value) {
      this.end = value;
      this.emitChange();
      this.$emit('update:endDate', value);
    },
    emitChange () {
      this.$emit('change', [this.start, this.end]);
    },
  },
};
</script>

<style lang="scss" scoped></style>
